interface AppendUrlParam {
  base: string;
  urlParam: unknown;
}

export const appendUrlParam = ({ base, urlParam }: AppendUrlParam): string => {
  const param = typeof urlParam === 'string' ? urlParam.trim() : '';

  return param ? `${base}${param}` : base;
};
